import { useEffect, useState } from "react";
import "react-quill/dist/quill.snow.css"; // Import Quill styles
import { useNavigate } from "react-router-dom";
import { useDataLayerValue } from "../../DataLayer/DataLayer";

import { createCardType, updateCardType } from "../../utils/ApiCalls/CardTypes";
import { checkFields } from "../../utils/Validation/checkFields";
import { uploadFile } from "../../utils/ApiCalls/Document";
import UploadFileImage from "../imageUpload/uploadFileImage";
import { constants } from "../../constants/constants";
import { MenuItem, Select } from "@mui/material";
import { addlog } from "../../utils/ApiCalls/Logs";

const CardTypeInput = ({ cardtype }) => {
  const [name, setName] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [isDefault, setIsDefault] = useState(false);
  const [card_code, setCardCode] = useState([]);
  const [{userDetails}, dispatch] = useDataLayerValue();
  const [card_type, setCardType] = useState("gaming");
  const [error, setError] = useState();
  const [selectedFile, setSelectedFile] = useState(null);
  const [image, setImage] = useState(cardtype?.image || null);
  const navigate = useNavigate();

  useEffect(() => {
    if (cardtype?.id) {
      setName(cardtype?.card_name);
      setCardCode(cardtype.card_code);
      setImage(cardtype?.image);
      setCardType(cardtype?.card_type);
      setIsActive(cardtype?.is_active === 1 ? true : false);
    }
  }, [cardtype]);
  const handleCheckboxChange = () => {
    setIsActive(!isActive);
  };

  const addcardtype = async (e) => {
    e.preventDefault();
    try {
      let added = false;
      let dataValues = {
        card_name: name,
        card_type,
        image: image,
        is_default: isDefault ? 1 : 0,
        card_code,
      };

      if (selectedFile) {
        let image = await uploadFile(
          selectedFile,
          undefined,
          undefined,
          typeof cardtype?.image === "string"
            ? cardtype.image.replace(constants.MEDIAURL + "/", "").replace(constants.MEDIAURL, "")
            : null
        );
        if (image?.error) throw new Error(image.error);
        dataValues.image = image?.url;
      }
      let valid = checkFields(dataValues);
      if (valid) {
        dispatch({
          type: "SET_ERROR_MESSAGE",
          errMess: { message: valid, type: "error" },
        });
        dispatch({
          type: "SET_LOADING",
          loading: false,
        });
        setError(valid);
      } else {
        setError();

        const values = {
          is_active: isActive ? 1 : 0,
          ...dataValues,
        };

        let data;
        if (cardtype?.id) {
          data = await updateCardType(cardtype.id, values);
        } else {
          data = await createCardType(values);
        }

        if (data?.error) {
          dispatch({
            type: "SET_ERROR_MESSAGE",
            errMess: { message: data.error, type: "error" },
          });
          added = false;
        } else {
          added = true;
        }
        if (cardtype?.id) {
          addlog(
            "Card Type Updated",
            "CardType",
            {
              id: cardtype.id,
            },
            userDetails.id
          );
        } else {
          addlog(
            "Card Type Created",
            "CardType",
            {
              id: data.id,
            },
            userDetails.id
          );
        }

        if (added && !cardtype.id) {
          navigate("/website/loyalty/card-types");
        } else {
          if (added) {
            navigate("/website/loyalty/card-types");
            dispatch({
              type: "SET_ERROR_MESSAGE",
              errMess: { message: "Values updated", type: "success" },
            });
          }
        }
      }
    } catch (e) {
      dispatch({
        type: "SET_ERROR_MESSAGE",
        errMess: { message: e.message, type: "error" },
      });
    }
  };
  return (
    <div>
      <section className="content">
        {error && (
          <div className="d-flex justify-content-center align-items-center text-danger">
            <p>{error}</p>
          </div>
        )}

        <div className="container-fluid">
          <div className="card">
            <form className="input_form" onSubmit={addcardtype}>
              <div className="card-body">
                <div className="row">
                  <UploadFileImage
                    className={"col-lg-12"}
                    mandatory={"*"}
                    image={
                      cardtype?.image
                        ? `${constants.MEDIAURL}/${cardtype?.image}`
                        : cardtype?.image
                    }
                    label={"Card Image"}
                    placeholder={"Upload Card Image"}
                    selectedFile={selectedFile}
                    setSelectedFile={setSelectedFile}
                  />
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Name</label>
                      <input
                        required
                        className="f_input"
                        type="name"
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Card Code</label>
                      <input
                        required
                        className="f_input"
                        type="text"
                        value={card_code}
                        onChange={(e) => setCardCode(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-lg-4 col-md-12 col-sm-12 col-12">
                    <div className="fieldrow">
                      <label className="f_label">Card Type</label>
                      <Select
                        style={{ width: "100%", height: "45px" }}
                        value={card_type}
                        onChange={(e) => setCardType(e.target.value)}
                      >
                        <MenuItem value={"gaming"}>Gaming</MenuItem>
                        <MenuItem value={"non-gaming"}>Non Gaming</MenuItem>
                      </Select>
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <div className="iti_inner">
                    <div className="icheck-primary d-inline">
                      <input
                        type="checkbox"
                        id="customCheckbox4"
                        name="r10"
                        checked={isActive}
                        onChange={handleCheckboxChange}
                      />
                      <label htmlFor="customCheckbox4">
                        {isActive ? (
                          <p>
                            <span style={{ fontWeight: 600 }}>Active</span>
                          </p>
                        ) : (
                          <p>
                            <span style={{ fontWeight: 200 }}>Active</span>
                          </p>
                        )}
                      </label>
                    </div>
                  </div>
                </div>
              </div>

              <div className="card-footer text-right">
                <button className="btn main_submit">
                  {cardtype?.id ? "Update" : "Add"} card type
                </button>
              </div>
            </form>
          </div>
          <div className="pt-3"></div>
        </div>
      </section>
    </div>
  );
};

export default CardTypeInput;
